function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import classnames from 'classnames';
import deprecate from 'util-deprecate';
import SvgIcon from '../../atoms/SvgIcon';
import Spinner from '../../atoms/Spinner';
import TextBox from '../../atoms/TextBox';

var TextBoxIcon = function TextBoxIcon(_ref) {
  var iconName = _ref.iconName,
      iconIsButton = _ref.iconIsButton,
      iconColor = _ref.iconColor,
      iconLabel = _ref.iconLabel,
      onClick = _ref.onClick,
      displayLoader = _ref.displayLoader;
  if (!iconName) return null;

  if (iconIsButton) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, displayLoader && /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'absolute',
        bottom: 0,
        top: 0,
        right: 0,
        padding: '4px 10px'
      }
    }, /*#__PURE__*/React.createElement(Spinner, {
      type: "sm"
    })), !displayLoader && /*#__PURE__*/React.createElement("button", {
      onClick: onClick,
      className: "textbox-with-icon__icon-wrapper textbox-with-icon__button button--stripped",
      "aria-label": iconLabel
    }, /*#__PURE__*/React.createElement(SvgIcon, {
      className: "textbox-with-icon__icon",
      iconName: iconName,
      color: iconColor
    })));
  }

  return /*#__PURE__*/React.createElement("span", {
    className: "textbox-with-icon__icon-wrapper",
    "aria-label": iconLabel
  }, /*#__PURE__*/React.createElement(SvgIcon, {
    className: "textbox-with-icon__icon",
    iconName: iconName,
    color: iconColor
  }));
};
/**
 * Status: *finished*.
 * Category: FormElements
 **/


var TextBoxWithIcon = /*#__PURE__*/React.forwardRef(deprecate(function (_ref2, ref) {
  var _classnames;

  var className = _ref2.className,
      type = _ref2.type,
      placeholder = _ref2.placeholder,
      disabled = _ref2.disabled,
      error = _ref2.error,
      small = _ref2.small,
      iconName = _ref2.iconName,
      iconColor = _ref2.iconColor,
      iconIsButton = _ref2.iconIsButton,
      iconLabel = _ref2.iconLabel,
      onIconClick = _ref2.onIconClick,
      displayLoader = _ref2.displayLoader,
      rest = _objectWithoutProperties(_ref2, ["className", "type", "placeholder", "disabled", "error", "small", "iconName", "iconColor", "iconIsButton", "iconLabel", "onIconClick", "displayLoader"]);

  return /*#__PURE__*/React.createElement("div", {
    className: classnames('textbox-with-icon', (_classnames = {}, _defineProperty(_classnames, 'textbox-with-icon--small', small), _defineProperty(_classnames, className, className), _classnames))
  }, /*#__PURE__*/React.createElement(TextBox, _extends({
    ref: ref,
    type: type,
    placeholder: placeholder,
    disabled: disabled,
    error: error,
    small: small
  }, rest)), /*#__PURE__*/React.createElement(TextBoxIcon, {
    iconName: iconName,
    iconIsButton: iconIsButton,
    iconColor: iconColor,
    iconLabel: iconLabel,
    onClick: onIconClick,
    displayLoader: displayLoader
  }));
}, '<TextBoxWithIcon/> from Telia Styleguide is a deprecated component. Use <TextField/> instead'));
TextBoxWithIcon.displayName = 'TextBoxWithIcon';
TextBoxWithIcon.defaultProps = {
  iconColor: 'black',
  placeholder: '',
  onChange: function onChange() {}
};
export default TextBoxWithIcon;